/**
 * MTM: pile på produktbilledet, der looper (fra sidste billede videre til første og omvendt).
 * Bruges i snippets/product-gallery.liquid: <mtm-gallery-loop-button direction="next|prev" aria-controls="...">
 * Styrer temaets <scroll-carousel> via dets offentlige API (cells, selectedIndex, select()).
 */
if (!window.customElements.get('mtm-gallery-loop-button')) {
  window.customElements.define('mtm-gallery-loop-button', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    get carousel() {
      return document.getElementById(this.getAttribute('aria-controls'));
    }

    onClick = () => {
      const carousel = this.carousel;
      if (!carousel || typeof carousel.select !== 'function') return;

      const count = carousel.cells.length; // kun synlige billeder (respekterer variant-filtrering)
      if (count < 2) return;

      const step = this.getAttribute('direction') === 'prev' ? -1 : 1;
      carousel.select((carousel.selectedIndex + step + count) % count);
    };
  });
}
